import { render, staticRenderFns } from "./ElaryWarningInfoList.vue?vue&type=template&id=5fa8d3da&scoped=true"
import script from "./ElaryWarningInfoList.vue?vue&type=script&lang=js"
export * from "./ElaryWarningInfoList.vue?vue&type=script&lang=js"
import style0 from "./ElaryWarningInfoList.vue?vue&type=style&index=0&id=5fa8d3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8d3da",
  null
  
)

export default component.exports